const getXMLPropertyValue = (xml: string, property: string) => {
  const parser = new DOMParser();
  const parsed = parser.parseFromString(xml, 'text/xml');

  return parsed.getElementsByTagName(property)[0]?.childNodes[0]?.nodeValue;
};

export { getXMLPropertyValue };
